import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_LIFT_CANDIDATE_REFUSAL = gql`
    mutation OnboardingLiftCandidateRefusal($candidateUuid: ID!) {
        onboardingLiftCandidateRefusal(candidateUuid: $candidateUuid) {
            uuid
            step
            refused
            refusalComment
            refusedAt
        }
    }
`;

const useOnboardingLiftCandidateRefusal = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_LIFT_CANDIDATE_REFUSAL);

    const liftCandidateRefusal = async (candidateUuid) => {
        return mutate({
            variables: { candidateUuid },
        });
    };

    return {
        liftCandidateRefusal,
        loading,
        error,
    };
};

export default useOnboardingLiftCandidateRefusal;
